import router from './router';

export const load = (app) => {
	app.config(router);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/quoting/publicHolidays/index.js